var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAusralia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5,
    fill: "white",
    stroke: "#DCF1FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 14.9062H39V33.9062H11V14.9062Z",
    fill: "#0052B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.218 24.4067C23.233 24.3897 23.2477 24.3728 23.2625 24.3557C23.2477 24.3728 23.2326 24.3896 23.2176 24.4067H23.218ZM21.3488 26.7405L21.9481 28.0159L23.3014 27.6976L22.6953 28.9697L23.7836 29.8481L22.4287 30.159L22.4324 31.5727L21.3488 30.6882L20.2652 31.5727L20.269 30.159L18.9141 29.8481L20.0023 28.9697L19.3962 27.6976L20.7495 28.0159L21.3488 26.7405ZM32.1692 28.3249L32.4551 28.9332L33.1005 28.7814L32.8115 29.3881L33.3306 29.8071L32.6843 29.9554L32.686 30.6297L32.1692 30.2078L31.6524 30.6297L31.6542 29.9554L31.0079 29.8071L31.527 29.3881L31.2379 28.7814L31.8834 28.9332L32.1692 28.3249ZM29.5101 21.8713L29.796 22.4797L30.4415 22.3278L30.1524 22.9346L30.6714 23.3536L30.0252 23.5018L30.0269 24.1762L29.5101 23.7543L28.9933 24.1762L28.9951 23.5018L28.3488 23.3536L28.8678 22.9346L28.5789 22.3278L29.2243 22.4797L29.5101 21.8713ZM32.1692 18.1836L32.4551 18.792L33.1005 18.64L32.8115 19.2469L33.3305 19.6659L32.6843 19.8141L32.686 20.4885L32.1692 20.0665L31.6524 20.4885L31.6542 19.8141L31.0079 19.6659L31.527 19.2469L31.2379 18.64L31.8834 18.792L32.1692 18.1836ZM34.4919 20.9494L34.7777 21.5577L35.4231 21.4059L35.1342 22.0126L35.6532 22.4316L35.0069 22.5799L35.0087 23.2542L34.4919 22.8324L33.9751 23.2542L33.9768 22.5799L33.3306 22.4316L33.8496 22.0126L33.5605 21.4059L34.206 21.5577L34.4919 20.9494ZM32.8311 24.1762L33.0559 24.8805H33.7834L33.1948 25.3158L33.4197 26.02L32.8311 25.5848L32.2424 26.02L32.4673 25.3158L31.8787 24.8805H32.6062L32.8311 24.1762Z",
    fill: "#F0F0F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 14.9062V16.6069L22.5299 18.004H25V21.3082H21.7678L25 23.1359V24.4059H23.5409L19.5217 22.1334V24.4059H16.4783V21.7022L11.6969 24.4059H11V22.7053L13.4701 21.3082H11V18.004H14.2322L11 16.1757V14.9062H12.4591L16.4783 17.1788V14.9062H19.5217V17.61L24.3031 14.9062H25Z",
    fill: "#F0F0F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.875 14.9062H17.125V18.7655H11V20.5467H17.125V24.4061H18.875V20.5467H25V18.7655H18.875V14.9062Z",
    fill: "#D80027"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5234 21.3086L25.0017 24.4064V23.5304L21.0726 21.3086H19.5234Z",
    fill: "#0052B4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5234 21.3086L25.0017 24.4064V23.5304L21.0726 21.3086H19.5234Z",
    fill: "#F0F0F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5217 21.3086L25 24.4064V23.5304L21.0709 21.3086H19.5217ZM14.9291 21.3086L11 23.5304V24.4064L16.4783 21.3086H14.9291Z",
    fill: "#D80027"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4783 18.004L11 14.9062V15.7822L14.9291 18.004H16.4783Z",
    fill: "#0052B4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4783 18.004L11 14.9062V15.7822L14.9291 18.004H16.4783Z",
    fill: "#F0F0F0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4783 18.004L11 14.9062V15.7822L14.9291 18.004H16.4783ZM21.0709 18.004L25 15.7822V14.9062L19.5217 18.004H21.0709Z",
    fill: "#D80027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAusralia);
export default __webpack_public_path__ + "static/media/ausralia.b0220966ce7b347f42d688dd6327299a.svg";
export { ForwardRef as ReactComponent };